<button *ngIf="!isDisplayed" [type]="type" [ngClass]="customCssClass || 'btn btn-primary'" [disabled]="isDisabled">
  <ng-content></ng-content>
</button>
